/**

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

import { forwardRef } from "react";
import type { ComponentProps, ElementType, ReactNode } from "react";
import type { TypographyProps } from "@mui/material/Typography";

// Custom styles for VuiTypography
import VuiTypographyRoot from "components/VuiTypography/VuiTypographyRoot";

type OwnerState = ComponentProps<typeof VuiTypographyRoot>["ownerState"];

type VuiTypographyProps = Omit<TypographyProps, keyof OwnerState | "children"> &
  Partial<OwnerState> & {
    component?: ElementType;
    // For component="a".
    href?: string;
    children: ReactNode;
  };

const VuiTypography = forwardRef<HTMLSpanElement, VuiTypographyProps>(
  (
    {
      color = "dark",
      fontWeight = false,
      textTransform = "none",
      verticalAlign = "unset",
      textGradient = false,
      opacity = 1,
      children,
      ...rest
    },
    ref
  ) => (
    <VuiTypographyRoot
      {...rest}
      ref={ref}
      ownerState={{ color, textTransform, verticalAlign, fontWeight, opacity, textGradient }}
    >
      {children}
    </VuiTypographyRoot>
  )
);

export default VuiTypography;
